<svg xmlns="http://www.w3.org/2000/svg" width="174" height="138" viewBox="0 0 174 138" fill="none">
	<g id="Upload Error">
		<g id="415">
			<g id="Group 674">
				<g id="Group 667">
					<path
						id="Vector"
						d="M88.7 117.919C116.7 117.919 139.4 95.2188 139.4 67.1189C139.4 39.0189 116.6 16.3188 88.7 16.3188C60.7 16.3188 38 39.0189 38 67.1189C38 95.2188 60.7 117.919 88.7 117.919Z"
						fill="#F2EAF9"
					/>
					<path
						id="Vector_2"
						d="M135.7 33.9188C137.964 33.9188 139.8 32.0831 139.8 29.8188C139.8 27.5544 137.964 25.7188 135.7 25.7188C133.436 25.7188 131.6 27.5544 131.6 29.8188C131.6 32.0831 133.436 33.9188 135.7 33.9188Z"
						fill="#F4F1F9"
					/>
					<path
						id="Vector_3"
						d="M141.7 17.9188C143.246 17.9188 144.5 16.6652 144.5 15.1188C144.5 13.5725 143.246 12.3188 141.7 12.3188C140.154 12.3188 138.9 13.5725 138.9 15.1188C138.9 16.6652 140.154 17.9188 141.7 17.9188Z"
						fill="#F2EAF9"
					/>
					<path
						id="Vector_4"
						d="M33.8 40.9188C35.3464 40.9188 36.6 39.6652 36.6 38.1188C36.6 36.5725 35.3464 35.3188 33.8 35.3188C32.2536 35.3188 31 36.5725 31 38.1188C31 39.6652 32.2536 40.9188 33.8 40.9188Z"
						fill="#F2EAF9"
					/>
					<path
						id="Vector_5"
						d="M49.2 118.719C52.0719 118.719 54.4 116.391 54.4 113.519C54.4 110.647 52.0719 108.319 49.2 108.319C46.3281 108.319 44 110.647 44 113.519C44 116.391 46.3281 118.719 49.2 118.719Z"
						fill="#F2EAF9"
					/>
				</g>
			</g>
		</g>
		<g id="416">
			<g id="Group 645">
				<g id="Group">
					<g id="Group 675">
						<g id="Group_2">
							<g id="Vector_6" filter="url(#filter0_d_533_775)">
								<path
									d="M152 80.7235C152 93.6448 141.55 104.094 128.517 104.094C128.292 104.094 126.382 104.094 112.337 104.094C102.562 104.094 86.9438 104.094 62 104.094H50.0899C34.4719 104.431 22 91.9594 22 76.9032C22 61.7347 34.5843 49.1505 50.4269 49.937C64.0224 7.4651 126.27 13.4202 131.55 57.3527C143.236 58.8134 152 68.701 152 80.7235Z"
									fill="url(#paint0_linear_533_775)"
								/>
							</g>
						</g>
						<path
							id="Vector_7"
							d="M128.517 104.094C141.438 104.094 152 93.6446 152 80.7233C152 67.802 141.438 57.3525 128.517 57.3525C115.596 57.3525 105.034 67.802 105.034 80.7233C105.034 93.6446 115.596 104.094 128.517 104.094Z"
							fill="url(#paint1_linear_533_775)"
						/>
						<path
							id="Vector_8"
							d="M90.2022 104.319C113.236 104.319 132 85.6673 132 62.6336C132 39.5999 113.236 20.9482 90.2022 20.9482C67.1685 20.9482 48.4045 39.5999 48.4045 62.6336C48.4045 85.6673 67.0561 104.319 90.2022 104.319Z"
							fill="url(#paint2_linear_533_775)"
						/>
					</g>
				</g>
			</g>
		</g>
		<path
			id="Vector_9"
			d="M78.6176 63.8291L80.5724 61.8699C81.1425 61.2984 81.1425 60.3188 80.5724 59.7474C80.0023 59.176 79.0249 59.176 78.4548 59.7474L76.5 61.7066L74.5452 59.7474C73.9751 59.176 72.9977 59.176 72.4276 59.7474C71.8575 60.3188 71.8575 61.2984 72.4276 61.8699L74.3824 63.8291L72.4276 65.7882C71.8575 66.3597 71.8575 67.3393 72.4276 67.9107C72.7534 68.2372 73.0792 68.3188 73.4864 68.3188C73.8937 68.3188 74.2195 68.1556 74.5452 67.9107L76.5 65.9515L78.4548 67.9107C78.7805 68.2372 79.1063 68.3188 79.5136 68.3188C79.9208 68.3188 80.2466 68.1556 80.5724 67.9107C81.1425 67.3393 81.1425 66.3597 80.5724 65.7882L78.6176 63.8291Z"
			fill="#A398B0"
		/>
		<path
			id="Vector_10"
			d="M99.3529 63.8291L101.525 61.8699C102.158 61.2984 102.158 60.3188 101.525 59.7474C100.891 59.176 99.8054 59.176 99.1719 59.7474L97 61.7066L94.8281 59.7474C94.1946 59.176 93.1086 59.176 92.4751 59.7474C91.8416 60.3188 91.8416 61.2984 92.4751 61.8699L94.6471 63.8291L92.4751 65.7882C91.8416 66.3597 91.8416 67.3393 92.4751 67.9107C92.8371 68.2372 93.1991 68.3188 93.6516 68.3188C94.1041 68.3188 94.4661 68.1556 94.8281 67.9107L97 65.9515L99.1719 67.9107C99.5339 68.2372 99.8959 68.3188 100.348 68.3188C100.801 68.3188 101.163 68.1556 101.525 67.9107C102.158 67.3393 102.158 66.3597 101.525 65.7882L99.3529 63.8291Z"
			fill="#A398B0"
		/>
		<path
			id="Vector 22 (Stroke)"
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M42.7363 24.3707C42.9707 23.4486 43.9082 22.8911 44.8303 23.1255L51.3505 24.7828C52.2726 25.0172 52.8301 25.9547 52.5957 26.8768C52.3614 27.799 51.4238 28.3565 50.5017 28.1221L43.9815 26.4647C43.0594 26.2304 42.5019 25.2928 42.7363 24.3707Z"
			fill="#A398B0"
		/>
		<path
			id="Vector 23 (Stroke)"
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M48.2765 6.03412C49.0637 5.49977 50.135 5.70477 50.6694 6.49199L58.4638 17.975C58.9982 18.7622 58.7932 19.8336 58.0059 20.3679C57.2187 20.9023 56.1474 20.6973 55.613 19.91L47.8186 8.42703C47.2843 7.63981 47.4892 6.56847 48.2765 6.03412Z"
			fill="#A398B0"
		/>
		<path
			id="Vector 24 (Stroke)"
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M62.7351 0.855132C63.6684 0.670394 64.5748 1.27725 64.7595 2.21059L67.4543 15.825C67.639 16.7583 67.0322 17.6647 66.0988 17.8494C65.1655 18.0341 64.2591 17.4273 64.0744 16.4939L61.3796 2.87958C61.1949 1.94625 61.8018 1.03987 62.7351 0.855132Z"
			fill="#A398B0"
		/>
		<rect id="Rectangle 332" x="76" y="77.3188" width="23" height="3" fill="#A398B0" />
		<path
			id="Rectangle 333"
			d="M90 78.3188H94V83.3188C94 84.4234 93.1046 85.3188 92 85.3188C90.8954 85.3188 90 84.4234 90 83.3188V78.3188Z"
			fill="#A398B0"
		/>
		<path
			id="Vector_11"
			d="M142.594 34.3836C142.168 36.1802 141.528 37.9078 140.746 39.4971C138.686 43.2287 135.63 46.2691 131.793 48.1349C127.813 50.1389 123.123 50.8299 118.362 49.9316C107.276 47.6512 100.099 37.1477 102.444 26.2986C104.789 15.4496 115.52 8.47031 126.676 10.7507C130.656 11.5799 134.138 13.4457 137.051 16.1406C141.883 20.9778 143.944 27.8189 142.594 34.3836Z"
			fill="url(#paint3_linear_533_775)"
		/>
		<path
			id="Vector_12"
			d="M119.508 20.4631L119.508 20.4631L119.509 20.4711L120.321 30.5479C120.39 31.7476 121.315 32.8188 122.5 32.8188C123.685 32.8188 124.61 31.7476 124.679 30.5479L125.491 20.4711L125.491 20.4711L125.492 20.4619C125.614 18.5051 124.32 16.8188 122.5 16.8188C120.674 16.8188 119.386 18.5739 119.508 20.4631Z"
			fill="white"
			stroke="white"
		/>
		<path
			id="Vector_13"
			d="M122.5 36.8188C120.835 36.8188 119.5 38.1538 119.5 39.8188C119.5 41.4839 120.835 42.8188 122.5 42.8188C124.165 42.8188 125.5 41.4839 125.5 39.8188C125.5 38.1538 124.165 36.8188 122.5 36.8188Z"
			fill="white"
			stroke="white"
		/>
	</g>
	<defs>
		<filter
			id="filter0_d_533_775"
			x="0"
			y="10.0498"
			width="174"
			height="127.051"
			filterUnits="userSpaceOnUse"
			color-interpolation-filters="sRGB"
		>
			<feFlood flood-opacity="0" result="BackgroundImageFix" />
			<feColorMatrix
				in="SourceAlpha"
				type="matrix"
				values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				result="hardAlpha"
			/>
			<feOffset dy="11" />
			<feGaussianBlur stdDeviation="11" />
			<feColorMatrix
				type="matrix"
				values="0 0 0 0 0.454442 0 0 0 0 0.397708 0 0 0 0 0.575 0 0 0 0.27 0"
			/>
			<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_533_775" />
			<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_533_775" result="shape" />
		</filter>
		<linearGradient
			id="paint0_linear_533_775"
			x1="86.9999"
			y1="55.3697"
			x2="86.9576"
			y2="104.996"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="white" />
			<stop offset="0.9964" stop-color="#F0ECF5" />
		</linearGradient>
		<linearGradient
			id="paint1_linear_533_775"
			x1="102.535"
			y1="52.3209"
			x2="123.352"
			y2="75.089"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#C5BCE1" />
			<stop offset="0.9942" stop-color="white" stop-opacity="0" />
		</linearGradient>
		<linearGradient
			id="paint2_linear_533_775"
			x1="44.4905"
			y1="43.5053"
			x2="77.3009"
			y2="56.345"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#E7E2F0" />
			<stop offset="0.9942" stop-color="white" stop-opacity="0" />
		</linearGradient>
		<linearGradient
			id="paint3_linear_533_775"
			x1="101.981"
			y1="30.3232"
			x2="143.007"
			y2="30.3232"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#B9B0CC" />
			<stop offset="1" stop-color="#A196AE" />
		</linearGradient>
	</defs>
</svg>
